import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { appConfigService } from '@app/config';
import { ParentItemProviderService } from '@app/shared';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import {
  AuthRequestOptions,
  ItemInfo,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { first, switchMap } from 'rxjs';

@Component({
  selector: `app-odabir-jedinice-za-restauraciju`,
  templateUrl: './odabir-jedinice-za-restauraciju.component.html'
})
export class OdabirJediniceZaRestauracijuComponent {
  public showDialog = false;

  private parentItemViewProvider = inject(ParentItemProviderService);
  private listviewProvider = inject(ListViewProviderDirective);
  private notificationService = inject(NotificationService);

  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(jedinice: JedinicaGradiva[]) {
    return this.parentItemViewProvider.parentItem$
      .pipe(
        first(),
        switchMap((parent: any) => {
          const formData = {
            jediniceGradivaIds: jedinice.map(
              (j) => j['en~jedinica_gradiva~id']
            ),
            restauracijaId: new ItemInfo(parent).id
          };

          return this.httpClient.post(
            `${this.config.apiHost}restauracija`,
            formData,
            new AuthRequestOptions()
          );
        })
      )
      .subscribe({
        next: () => {
          const message =
            jedinice.length > 1
              ? 'Jedinice gradiva uspješno dodane u restauraciju'
              : 'Jedinica gradiva uspješno dodana u restauraciju';
          this.notificationService.success(message);
          this.listviewProvider.refresh();
        },
        error: () => {
          const errorMessage =
            jedinice.length > 1
              ? 'Greška pri dodavanju jedinica gradiva'
              : 'Greška pri dodavanju jedinice gradiva';
          this.notificationService.error(errorMessage);
        },
        complete: () => {
          this.showDialog = false;
        }
      });
  }
}
